import { View, StyleSheet, Pressable } from "react-native";
import { Image } from "./image";
import Text from "./text";

import { ImageMapper } from "src/common/assets/images";
import useUserAddress from "../libs/hooks/useUserAddress";
import useSelectedAddress from "../libs/hooks/useSelectedAddress";
import variables from "../assets/variables";
import { useNavigation } from "@react-navigation/native";
import { getAddress } from "../libs/utils/maps";
import useLocation from "../libs/hooks/useLocation";
import { useDispatch } from "react-redux";
import { geocoding } from "../toolkit/features/mapbox";
import { useEffect } from "react";
import { SelectedAddressType } from "../libs/types/EditProfileScreen";
import { setSelectedAddress } from "../toolkit/features/selectedAddress";
import { DEFAULT_LOCATION } from "../libs/utils/location";

const LocationSelection = () => {
  const { address, loading } = useUserAddress();
  const selectedAddress = useSelectedAddress();
  const navigation = useNavigation<any>();
  const location = useLocation();
  const dispatch = useDispatch<any>();

  const selectedAddressObject = selectedAddress || getAddress(address?.[0]);

  const onClick = () => {
    navigation.navigate("SearchAddress");
  };

  useEffect(() => {
    if (!selectedAddressObject?.location && location?.location) {
      if (
        location?.location?.coords?.latitude ==
          DEFAULT_LOCATION.location.latitude &&
        location?.location?.coords?.longitude ==
          DEFAULT_LOCATION.location.longitude
      ) {
        dispatch(setSelectedAddress(DEFAULT_LOCATION));
      } else {
        getGeocode(location);
      }
    }
  }, [location]);

  const setLocationData = (properties) => {
    const { coordinates, name, place_formatted } = properties;
    let selectedAddress: SelectedAddressType;
    selectedAddress = {
      name,
      description: place_formatted,
      location: coordinates,
    };
    dispatch(setSelectedAddress(selectedAddress));
  };

  const getGeocode = (location) => {
    dispatch(
      geocoding({
        lat: location?.location?.coords?.latitude,
        lon: location?.location?.coords?.longitude,
      })
    ).then((res) => {
      const feature = res?.payload?.features?.[0];
      setLocationData(feature?.properties || {});
    });
  };

  if (!selectedAddressObject?.location) {
    return <View style={styles.root} />;
  }

  return (
    <Pressable onPress={onClick}>
      <View style={styles.root}>
        <View style={styles.nameContainer}>
          <Image source={ImageMapper.Navigation} style={styles.icon} />
          <Text style={styles.addressName} numberOfLines={1}>{selectedAddressObject.name}</Text>
          <Image source={ImageMapper.Down} style={styles.down} />
        </View>
        <Text style={styles.address} numberOfLines={1}>
          {selectedAddressObject.description}
        </Text>
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  nameContainer: {
    flexDirection: "row",
  },
  icon: {
    height: 22,
    width: 22,
  },
  root: {
    padding: 20,
    backgroundColor: "#fff",
  },
  addressName: {
    color: variables.$textDark,
    fontFamily: "MontserratBold",
    marginLeft: 10,
  },
  address: {
    color: variables.$textDark,
    fontSize: 14,
    marginRight: 30,
  },
  down: {
    height: 20,
    width: 20,
    marginLeft: 4,
  },
});

export default LocationSelection;
